<!--
  @description: 微信通知服务 - 发送记录页面
  @author: system
  @date: 2026-06-02
  @note: 展示所有发送通知的历史记录，包括自动和手动发送
-->
<template>
  <div class="send-record-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2 class="page-title">
        <i class="el-icon-document"></i>
        发送记录
      </h2>
      <p class="page-desc">查看所有通知的发送历史记录</p>
    </div>-->

    <!-- 筛选查询框 -->
    <div class="filter-container">
      <el-form :inline="true">
        <el-form-item label="公众号:" style="margin:0 10px" size="small">
          <el-select
            v-model="listQuery.appid"
            placeholder="请选择公众号"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="item in gzhList"
              :key="item.appid"
              :label="item.account_name"
              :value="item.appid"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名称:" style="margin:0 10px" size="small">
          <el-input
            v-model="listQuery.user_name"
            placeholder="请输入用户名称"
            clearable
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户公众号openid:" style="margin:0 10px" size="small">
          <el-input
            v-model="listQuery.gzh_openid"
            placeholder="请输入"
            clearable
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="getListData" size="small" icon="el-icon-search" v-waves>搜索</el-button>
        <el-button type="default" @click="resetSearch" size="small" icon="el-icon-refresh">重置</el-button>
      </el-form>
    </div>

    <!-- 表格列表 -->
    <div class="table-container">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <!-- 所属公众号 -->
        <!-- <template slot="appid" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
              arrayByIdToNameStr({
                ArrayData: gzhList,
                ID: row.appid,
                id_key:'appid',
                name_key:'account_name'
              }) || '-'
            }}
          </el-tag>
        </template>-->

        <!-- 消息模版 -->
        <template slot="template_id" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
            arrayByIdToNameStr({
            ArrayData: templateList,
            ID: row.template_id
            })
            }}
          </el-tag>
        </template>
        <!-- 发送方式 -->
        <template slot="send_status" slot-scope="{ row }">
          <el-tag
            :type="row.send_status == 0 ? 'success' : 'danger'"
            size="small"
          >{{ row.send_status == 0 ? '成功' : '失败' }}</el-tag>
        </template>

        <!-- 发送方式 -->
        <template slot="send_way" slot-scope="{ row }">
          <el-tag
            :type="row.send_way == 1 ? 'primary' : 'warning'"
            size="small"
          >{{ row.send_way == 1 ? '自动发送' : '手动发送' }}</el-tag>
        </template>

        <template slot="user_name" slot-scope="{ row }">
          <el-tooltip
            v-if="row.user_name"
            effect="dark"
            :content="'公众号openid: ' + (row.gzh_openid || '未知')"
            placement="top"
          >
            <span style="cursor: pointer; color: #409EFF;">{{ row.user_name }}</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>

        <!-- 操作按钮 -->
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" style="color: #F56C6C;" @click="handleDelete(row)">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
/**
 * @description 发送记录页面
 * @component SendRecordList
 * @requires services/sendService/sendRecord - 发送记录相关API
 * @requires services/sendService/sendTemplate - 模版相关API
 */
import { selectApi, deleteApi } from "@/services/sendService/sendRecord";
import { selectApi as selectTemplateApi } from "@/services/sendService/sendTemplate";
import { selectApi as selectGzhListApi } from "@/services/sendService/sendAccount";
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";

export default {
  name: "SendRecordList",
  components: {
    ElTable
  },
  created() {
    // 页面创建时获取发送记录列表、公众号列表和模版列表
    this.getGzhList();
    this.getListData();
    this.getTemplateData();
  },
  data() {
    return {
      arrayByIdToNameStr,
      // 列表加载状态
      loading: false,
      // 列表查询参数
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        appid: "",
        gzh_openid: "",
        user_name: ""
      },
      // 发送记录列表数据
      tableData: [],
      // 消息模版列表
      templateList: [],
      // 公众号列表
      gzhList: []
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  methods: {
    /**
     * @description 获取公众号列表
     */
    async getGzhList() {
      const { data, code } = await selectGzhListApi({
        pageNumber: 1,
        pageSize: 100
      });
      if (code === 200) {
        this.gzhList = data;
      }
    },

    /**
     * @description 获取消息模版列表
     */
    async getTemplateData() {
      const { data, code } = await selectTemplateApi({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.templateList = data.map(item => {
          return {
            ...item,
            name: item.template_name
          };
        });
      }
    },

    /**
     * @description 获取发送记录列表
     */
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /**
     * @description 页码改变事件
     * @param {number} pageNumber - 新的页码
     */
    handleCurrentChange(pageNumber) {
      this.listQuery.pageNumber = pageNumber;
      this.getListData();
    },

    /**
     * @description 每页条数改变事件
     * @param {number} pageSize - 新的每页条数
     */
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getListData();
    },

    /**
     * @description 重置搜索条件
     */
    resetSearch() {
      this.listQuery.appid = "";
      this.listQuery.gzh_openid = "";
      this.listQuery.user_name = "";
      this.listQuery.pageNumber = 1;
      this.getListData();
    },

    /**
     * @description 删除发送记录
     * @param {Object} row - 记录数据
     */
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该记录吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.getListData();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less">
.send-record-container {
  min-height: 100vh;
  // padding: 20px;
  // background: #f5f7fa;

  // 页面头部
  .page-header {
    margin-bottom: 24px;
    padding: 24px 30px;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(79, 172, 254, 0.3);

    .page-title {
      margin: 0 0 8px 0;
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      display: flex;
      align-items: center;
      gap: 12px;

      i {
        font-size: 32px;
      }
    }

    .page-desc {
      margin: 0;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
    }
  }

  // 筛选容器
  .filter-container {
    background: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    margin-bottom: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

    /deep/ .el-form {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 0;

      .el-form-item {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
      }

      .el-button {
        &.el-button--primary {
          background-color: #165dff;
          border-color: #165dff;

          &:hover,
          &:focus {
            background-color: #4080ff;
            border-color: #4080ff;
          }
        }
      }
    }
  }

  // 表格容器
  .table-container {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    min-height: calc(100vh - 200px);

    /deep/ .el-table__empty-block {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 400px;
      width: 100% !important;

      .el-table__empty-text {
        text-align: center;
        line-height: 1.6;
      }
    }

    .operation {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .send-record-container {
    padding: 10px;

    .page-header {
      padding: 20px;

      .page-title {
        font-size: 22px;

        i {
          font-size: 26px;
        }
      }
    }

    .filter-container {
      padding: 15px;

      /deep/ .el-form {
        .el-form-item {
          width: 100%;
          margin-bottom: 10px;

          label {
            display: block;
            margin-bottom: 5px;
          }

          .el-input {
            width: 100% !important;
          }
        }

        .el-button {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
